module.exports = __webpack_public_path__ + "static/pillarbox2.5dca0835.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/projects/pillarbox2.jpg
// module id = 360
// module chunks = 35783957827783